import React, { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import api from "../../globals/axios";
import LoaderContainer from "../../components/LoaderContainer";
import { Typography } from "@mui/material";

const CropGrowthChart = ({ farmId, date }) => {
  const [growthData, setGrowthData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGrowthData = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          `/satellitedata/get-farm-crop-growth-data/${farmId}/?date=${date}`
        );
        const processedData = response.data.data;
        setGrowthData(processedData);
        setError(null);
      } catch (err) {
        console.error("Error fetching crop growth data:", err);
        setError("Failed to fetch crop growth data");
      } finally {
        setLoading(false);
      }
    };

    if (farmId) {
      fetchGrowthData();
    }
  }, [farmId]);

  if (loading) return <LoaderContainer loading={loading} />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!growthData) return null;

  const data = growthData.map((ele) => {
    return {
      date: ele.date,
      "Attainable Crop Growth (kg/ha)": ele.attainable_crop_production,
      "Actual Crop Growth (kg/ha)": ele.actual_crop_production,
    };
  });

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="date"
          tick={{ angle: -45, textAnchor: "end" }}
          height={60}
          interval="equidistantPreserveStartEnd"
        />
        <YAxis
          tick={{ angle: 0, textAnchor: "end" }}
          height={60}
          interval={0}
          domain={["auto", "auto"]}
        />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="Attainable Crop Growth (kg/ha)"
          stroke="green"
          strokeWidth={2}
          dot={false}
        />
        <Line
          type="monotone"
          dataKey="Actual Crop Growth (kg/ha)"
          stroke="orange"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default CropGrowthChart;
